import { notify } from "../../../../utils/notify";
import { searchV3 } from "../../../BaseRepositoryComponents";

const searchParams = new URLSearchParams(window.location.search);

const headers = new Headers();
const token = `Bearer ${searchParams.get("gfAccessToken") || ""}`;
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export const getOpenFinanceAgencies = async function findContractType() {
  if (!token)
    return notify(
      "Não foi possível conectar aos nossos servidores, tente novamente mais tarde."
    );

  const url = new URL(
    `${process.env.REACT_APP_URL_API_ERP_V3}/multitenant/bank-reconcilliation/v1/open-finance`
  );

  url.searchParams.append("perPage", 50);

  return searchV3(decodeURIComponent(url), "GET", headers);
};

export const disconnectOpenFinance = async function disconnectOpenFinance(
  agencyId
) {
  if (!token)
    return notify(
      "Não foi possível conectar aos nossos servidores, tente novamente mais tarde."
    );

  const url = new URL(
    `${process.env.REACT_APP_URL_API_ERP_V3}/multitenant/open-finance/${agencyId}`
  );

  return searchV3(decodeURIComponent(url), "DELETE", headers);
};

export async function getOpenFinanceRetroactive(agencyId, startDate, endDate) {
  if (!token)
    return notify(
      "Não foi possível conectar aos nossos servidores, tente novamente mais tarde."
    );

  const url = new URL(
    `${process.env.REACT_APP_URL_API_ERP_V3}/multitenant/open-finance/retroactive-transactions`
  );

  const body = {
    accountId: agencyId,
    startDate: startDate,
    endDate: endDate,
  };

  const options = {
    method: "POST",
    headers,
  };

  return searchV3(
    decodeURIComponent(url),
    options.method,
    options.headers,
    body
  );
}

export async function getOpenFinanceLog({ agencyId }) {
  if (!token)
    return notify(
      "Não foi possível conectar aos nossos servidores, tente novamente mais tarde."
    );

  const url = new URL(
    `${process.env.REACT_APP_URL_API_ERP_V3}/multitenant/bank-reconcilliation/v1/open-finance/${agencyId}/log`
  );

  return searchV3(decodeURIComponent(url), "GET", headers);
}
